import { cn } from '@/lib/utils';
import { useSize } from '@/services/explorer/useExplorerProvider';
import { useResourceThumbnail } from '@/utils/folder';
import { Thumbnail as GraphThumbnail, ThumbnailSet } from '@microsoft/microsoft-graph-types';
import { FC, PropsWithChildren } from 'react';

export const Thumbnail: FC<{ set?: ThumbnailSet; id: string; alt: string }> = ({ set, alt }) => {
  const thumbnail = set?.large;
  if (!thumbnail || !thumbnail.width || !thumbnail.height)
    return (
      <div className="mx-auto flex aspect-[6/4] max-h-full w-full items-center justify-center rounded-lg bg-gray-50">
        No thumbnail
      </div>
    );
  const sizes = [set.small, set.medium, set.large].filter(Boolean) as GraphThumbnail[];
  const srcSet = sizes.map(size => `${size.url} ${size.width}w`).join(', ');
  return (
    <img srcSet={srcSet} loading="lazy" alt={alt} className="mx-auto max-h-full max-w-full rounded-lg bg-gray-50" />
  );
};

export const ResourceThumbnail: FC<{ id: string; alt: string }> = ({ id }) => {
  const [set] = useResourceThumbnail(id);
  return <Thumbnail set={set} id={id} alt="Asset thumbnail" />;
};

export const ThumbnailContainer: FC<PropsWithChildren> = ({ children }) => {
  const [size] = useSize();
  return (
    <div
      className={cn(
        `flex aspect-[6/4] w-full items-center justify-center transition-transform hover:scale-[1.02]`,
        size.asset
      )}
    >
      {children}
    </div>
  );
};
